import React, { useState, useEffect } from "react";
// import "./Twheel.css";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  addbikenum,
  addbikedetails,
  addVahanData,
  QuickQuote_Post,
  quick_quoteValues,
  SelectAddons,
  Compare_quote,
} from "../../../Redux/actions/NumBikeation";
import { NavbarJourney } from "../../Navbar/NavbarJourney";
import {
  Form,
  Modal,
  Row,
  Col,
  Button,
  Avatar,
  Card,
  DatePicker,
  Spin,
  Select,
} from "antd/lib";
import BikeImg from "../../../images/bike-insur.jpg";
import BikeFrontImg from "../../../images/bike-front-face.jpg";
import moment from "moment";
import axiosInstance from "../../../Redux/axios/AxiosInstance";
import _ from "lodash";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { NewPlanBike } from "./NewPlanBike";
import NewBikeRegister from "./PopupRegister";
import axios from "axios";
const { Meta } = Card;

export default function NewBikemake() {
  const bikenum = useSelector((state) => state?.vehicledetail?.bikenum);
  const vechicleData = useSelector((state) => state?.common?.vahanData);
  const BikeMakeData = useSelector(
    (state) => state?.vehicledetail?.bikeMakeData
  );

  const [form] = Form.useForm();
  const [formLayout] = useState("vertical");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [bikeNumDetail, setBikeNumdeail] = useState(bikenum);
  const [options, setOptions] = useState([]);
  const [MakeData, setMakeData] = useState([]);
  const [ModalData, setModalData] = useState([]);
  const [VarientData, setVarientData] = useState([]);
  const [Makeoptions, setMakeoptions] = useState([]);
  const [VarientOption, setVarientOptions] = useState([]);
  const [bikemake, setBikeMake] = useState(BikeMakeData?.make);
  const [bikemodel, setModelSearch] = useState(BikeMakeData?.model);
  const [bikeVarient, setSelectVarient] = useState("");
  const [saveloading, setIsaveloading] = useState(false);
  const [rtoList, setrtoList] = useState([]);
  const [popVisible, setPopVisible] = useState(false);

  useEffect(() => {
    // form.setFieldsValue({
    //   BikeNumber: bikeNumDetail?.bike_number,
    //   manufacture: vechicleData?.registration_date
    //     ? moment(vechicleData?.registration_date)
    //     : null,
    // });
  }, [vechicleData, BikeMakeData]);

  useEffect(() => {
    axiosInstance
      .get(`vehicle_masters?no_of_wheels=2`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.makes;
        const makeData = resp.map((item) => item);
        // console.log("resp", makeData);
        setMakeoptions(makeData);
        setMakeData(makeData);
      })
      .catch((err) => {
        //console.log(err);
      });
  }, []);

  const onSelectMake = (data) => {
    //console.log("onSelect", data);
    setBikeMake(data);
    setIsaveloading(false);
    form.setFieldsValue({
      bikeModel: "",
      bikeVarient: "",
    });
  };
  //console.log(bikemake)

  useEffect(() => {
    axiosInstance
      .get(`vehicle_masters?no_of_wheels=2&make=${bikemake}`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.models;
        //console.log(resp);
        const modelData = resp.map((item) => item);
        // console.log("resp", modelData);
        setOptions(modelData);
        setModalData(modelData);
      })
      .catch((err) => {
        console.log(err.response);
      });
  }, [bikemake]);

  const handleSearch = (searchText) => {
    setIsaveloading(true);
    const filteredOptions = options.filter((option) =>
      option.toLowerCase().includes(searchText.toLowerCase())
    );
    setModalData(filteredOptions);
  };
  const ModelChange = (e) => {
    setModelSearch(e);
    setIsaveloading(false);
  };
  useEffect(() => {
    axiosInstance
      .get(`vehicle_masters?no_of_wheels=2&make=${bikemake}&model=${bikemodel}`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.variants;
        //console.log(resp);
        const varientData = resp.map((item) => item);
        // console.log("resp", varientData);
        setVarientOptions(resp);
        setVarientData(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [bikemodel]);

  const VarientChange = (variant, option) => {
    // console.log(variant,option)
    setSelectVarient(variant);
    axiosInstance
      .get(
        `vehicle_masters?no_of_wheels=2&make=${bikemake}&model=${bikemodel}&variant=${variant}`
      )
      .then((res) => {
        const resp = res?.data;
        dispatch(
          addbikedetails({
            ...BikeMakeData,
            VehicleCoreCode: resp?.vehicle_core_code,
            customized_variant: option?.label,
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
    setIsaveloading(false);
  };
  const OnRtoChange = (rto) => {
    axiosInstance
      .get(`/rto_masters?rto_code=${rto}`)
      .then((res) => {
        const resp = res?.data;
        console.log(resp);
        setrtoList(resp);
      })
      .catch((err) => {
        console.log(err);
      });
    setIsaveloading(false);
  };
  const OnSelectRto = (id, rto) => {
    dispatch(
      addbikedetails({
        ...BikeMakeData,
        selected_rto: rto?.label,
        selected_rto_id: id,
      })
    );
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  const debouncedHandleInputChange = _.debounce((e) => {
    setIsaveloading(true);
    const inputValue = e.target.value.toUpperCase();
    setBikeNumdeail({ ...bikeNumDetail, bike_number: inputValue });
    const updatedVal = {
      ...bikeNumDetail,
      bike_number: inputValue,
    };
    axiosInstance
      .post("getVehicleDetails", { vehicleNumber: inputValue })
      .then((res) => {
        //console.log(res);
        let bikeresult = res?.data?.data;
        //console.log(bikeresult)
        dispatch(addVahanData(bikeresult));
        dispatch(addbikenum(updatedVal));
        setIsaveloading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsaveloading(false);
      });
  }, 500);

  const handleInputChange = (e) => {
    debouncedHandleInputChange(e);
    form.setFieldsValue({ BikeNumber: e.target.value.toUpperCase() });
  };
  const handleCancelReg = () => {
    setPopVisible(false);
  };
  // const disabledDate = (current) => {
  //   const currentDate = moment();
  //   return current && current < currentDate.endOf("day");
  // };

  const disabledDate = (current) => {
    const currentDate = moment().endOf("day");
    return current && current > currentDate;
  };

  const getDefaultPickerValue = () => {
    const today = moment();
    return today;
  };
  // const handleDateChange = (date, dateString) => {
  //   console.log(date);
  //   console.log("dateString", dateString);
  //    setSelectedDate(dateString);
  // };
  const onFinish = (values) => {
    console.log("values", values);
    setLoading(true);
    const formattedYear = values.manufacture.format("YYYY");
    console.log("formattedYear", formattedYear);
    values.manufacture = formattedYear;
    dispatch(
      addbikedetails({
        ...BikeMakeData,
        make: values.bikeMake,
        model: values.bikeModel,
        year: values.manufacture,
        varbike: values.bikeVarient,
      })
    );
    dispatch(addbikenum(bikeNumDetail));

    const post = {
      vehicle_core_code: BikeMakeData?.VehicleCoreCode,
      rto_code: BikeMakeData?.selected_rto,
      year_of_manufacturing: values?.manufacture,
      // partnertype: 'P'
    };

    setTimeout(() => {
      dispatch(QuickQuote_Post(post));
      dispatch(quick_quoteValues(values));
      dispatch(SelectAddons([]));
      dispatch(Compare_quote([]));
      setLoading(false);
      setPopVisible(true);
      // history.push("/newVehiclelayout");
    }, 500);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  // const triggerApi = () => {
  //   axios
  //     .get("https://zoom-api.onrender.com/api/get_token")
  //     .then((res) => {
  //       console.log("res", res);
  //       // setToken(res.data.access_token)
  //       const token = res.data.access_token;
  //       if (token) {
  //         const headers = {
  //           Authorization: `Bearer ${token}`,
  //           Accept: "application/json",
  //         };
  //         const post = {
  //           topic: "2nd meeting",
  //           start_time: "2024-08-01T2:00:00Z",
  //           duration: 10,
  //           timezone: "UTC",
  //         };
  //         axios
  //           .post("https://zoom-api.onrender.com/api/create_meeting", post, {
  //             headers,
  //           })
  //           .then((res) => console.log(res))
  //           .catch((err) => {
  //             console.log("err", err);
  //           });
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err.response);
  //     });
  // };
  return (
    <>
      <NavbarJourney />
      {/* <BreadcrumbBike /> */}
      <section
        className="bg-light py-4"
        style={{ minHeight: "calc(100vh - 50px)" }}
      >
        <div className="container">
          <div className="row align-items-start justify-content-between">
            <Form
              layout={formLayout}
              form={form}
              className="ant-quote-form col-xl-6 col-lg-6 col-md-6"
              requiredMark={false}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <h6 className="ant-quote-form-head mt-4">
                Proceed Wihout Vehicle Number
              </h6>
              <Row gutter={24} className="mt-4">
                <Col span={12}>
                  <Form.Item
                    name="Rto_Code"
                    label="Select Rto"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Variant",
                      },
                    ]}
                    initialValue={BikeMakeData?.selected_rto}
                  >
                    <Select
                      placeholder="Search for Rto"
                      showSearch
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={rtoList?.map((p, index) => ({
                        key: index,
                        value: p.id,
                        label: p.rto_code,
                      }))}
                      onSearch={(rto) => OnRtoChange(rto)}
                      onSelect={(id, rto) => OnSelectRto(id, rto)}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Manufacture Year"
                    name="manufacture"
                    rules={[
                      {
                        required: true,
                        message: "please input Manufacture Year",
                      },
                    ]}
                    initialValue={
                      BikeMakeData?.year ? moment(BikeMakeData?.year) : null
                    }
                  >
                    <DatePicker
                      picker="year"
                      style={{ width: "100%", padding: "8px" }}
                      // format="YYYY-MM-DD"
                      disabledDate={disabledDate}
                      // onChange={handleDateChange}
                      // defaultPickerValue={getDefaultPickerValue()}
                      placeholder="Select Manufacture Year"
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="bikeMake"
                    label="Select Make"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Make",
                      },
                    ]}
                    initialValue={BikeMakeData?.make}
                  >
                    <Select
                      placeholder="Select Make"
                      showSearch
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={MakeData?.map((p, index) => ({
                        key: index,
                        value: p,
                        label: p,
                      }))}
                      onSelect={(e) => onSelectMake(e)}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="bikeModel"
                    label="Select Model"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Model",
                      },
                    ]}
                    initialValue={BikeMakeData?.model}
                  >
                    <Select
                      placeholder="Select Model"
                      showSearch
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={ModalData?.map((p, index) => ({
                        key: index,
                        value: p,
                        label: p,
                      }))}
                      // onChange={(e)=>ModelChange(e)}
                      onSelect={(e) => ModelChange(e)}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="bikeVarient"
                    label="Select Variant"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Variant",
                      },
                    ]}
                    initialValue={BikeMakeData?.varbike}
                  >
                    <Select
                      placeholder="Select Variant"
                      showSearch
                      filterOption={(input, option) =>
                        option.label
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      options={VarientData?.map((p, index) => ({
                        key: index,
                        value: p.variant,
                        label: p.customized_variant,
                      }))}
                      onChange={(variant, option) =>
                        VarientChange(variant, option)
                      }
                    />
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Form.Item {...buttonItemLayout}>
                    <Button
                      style={{ width: "100%" }}
                      loading={loading}
                      type="primary"
                      htmlType="submit"
                    >
                      GET QUOTES
                    </Button>
                  </Form.Item>
                </Col>
                {/* <Col span={24}>
                  <Form.Item {...buttonItemLayout}>
                    <Button
                      onClick={triggerApi}
                      style={{ width: "100%" }}
                      // loading={loading}
                      type="primary"
                      htmlType="submit"
                    >
                      Zoom
                    </Button>
                  </Form.Item>
                </Col> */}
              </Row>
            </Form>
            {/* { !isEdit ? (  */}
            <div className="col-xl-5 col-lg-6 col-md-6 bike-info-quotebef">
              <h1 className="bike-quotebef-txt">Your Vechicle Details</h1>
              <Card>
                <Spin spinning={saveloading}>
                  <Meta
                    avatar={<Avatar src={BikeFrontImg} />}
                    title={
                      <div className="meta-title-ant">
                        <p className="mb-0">
                          {BikeMakeData?.make ? BikeMakeData.make : bikemake}
                        </p>
                        <p className="mb-0">{BikeMakeData?.selected_rto}</p>
                      </div>
                    }
                    description={
                      <div className="meta-description-ant">
                        <p className="mb-0">
                          {BikeMakeData?.model ? BikeMakeData.model : bikemodel}
                        </p>
                        <p className="mb-0 text-end">
                          {BikeMakeData?.varbike
                            ? BikeMakeData.varbike
                            : bikeVarient}
                        </p>
                      </div>
                    }
                  />
                </Spin>
              </Card>
              <div className="vehdetail-img">
                <LazyLoadImage
                  effect="blur"
                  style={{ width: "85%", borderRadius: "10px" }}
                  alt="one"
                  src={BikeImg}
                />
                {/* <img src={BikeImg} style={{width: "85%", borderRadius: "10px",}}></img> */}
              </div>
            </div>
          </div>
        </div>
        <Modal
          title="Enter the Mobile number to proceed for Quote "
          open={popVisible}
          footer={null}
          onCancel={handleCancelReg}
          maskClosable={false}
        >
          <NewBikeRegister setPopVisible={setPopVisible} />
        </Modal>
      </section>
    </>
  );
}
